<template lang="pug">
app-collapse(title="Matrícula")
  el-row
    .breakText
      el-col(:span="12")
        app-display(
          label="CNS:",
          :content="getValue(imovel.cnsMatricula)"
        )
        app-display(
          label="Número:",
          :content="getValue(imovel.numeroMatricula)"
        )
      el-col(:span="12")
        app-display(
          label="Livro:",
          :content="getValue(imovel.livroMatricula)"
        )
        app-display(
          label="N° da folha:",
          :content="getValue(imovel.numeroFolhaMatricula)"
        )
      el-col.inputDiv(:span="12")
        app-display(
          label="Data da matrícula:",
          :content="formatDate(imovel.dataMatricula)"
        )
</template>
<script>
import utils from '@/utils/utils'
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
const {labelsCadastro, inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppDisplay,
    AppCollapse
  },
  data () {
    return {
      labelsCadastro,
      inputsExtraCadastro
    }
  },
  props: {
    imovel: {
      type: Object,
      required: true
    }
  },
  methods: {
    getValue (props) {
      return props || '-'
    },
    formatDate (value) {
      return value ? utils.formatDate(value) : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.breakText {
  word-break: break-all;
}

@media (max-width: 780px) {
  .breakText {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/common/InfoMatricula.vue